module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container container_grade container_com-fundo container_com-margem"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.salvarAporte.apply(null, arguments)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-do-aporte"
    }
  }, [_vm._v("Aporte")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.aporte.ValorDoAporte),
      expression: "aporte.ValorDoAporte"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "valor-do-aporte",
      "type": "text",
      "placeholder": "Insira o valor do aporte",
      "required": ""
    },
    domProps: {
      "value": (_vm.aporte.ValorDoAporte)
    },
    on: {
      "change": function($event) {
        return _vm.atualizarGrafico()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aporte, "ValorDoAporte", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Município")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aporte.CidadeId),
      expression: "aporte.CidadeId"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.aporte, "CidadeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cidades), function(cidade) {
    return _c('option', {
      domProps: {
        "value": cidade.Id
      }
    }, [_vm._v("\n                            " + _vm._s(cidade.Nome) + "\n                        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "numero-da-emenda"
    }
  }, [_vm._v("Número da emenda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aporte.NumeroDaEmenda),
      expression: "aporte.NumeroDaEmenda"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "numero-da-emenda",
      "type": "number",
      "placeholder": "Insira o número da emenda",
      "required": ""
    },
    domProps: {
      "value": (_vm.aporte.NumeroDaEmenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aporte, "NumeroDaEmenda", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "data-de-publicacao-da-emenda"
    }
  }, [_vm._v("Data de publicação da\n                        emenda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aporte.DataDePublicacaoDaEmenda),
      expression: "aporte.DataDePublicacaoDaEmenda"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "data-de-publicacao-da-emenda",
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.aporte.DataDePublicacaoDaEmenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aporte, "DataDePublicacaoDaEmenda", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, _vm._l((_vm.aporte.distribuicoesDoAportePorFaixa), function(distribuicaoPorFaixa, index) {
    return _c('div', {
      key: index,
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label",
      attrs: {
        "for": 'subsidio-faixa-' + (index + 1)
      }
    }, [_vm._v("\n                        Subsídio da " + _vm._s(distribuicaoPorFaixa.NomeDaFaixa) + "\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (distribuicaoPorFaixa.ValorDoSubsidio),
        expression: "distribuicaoPorFaixa.ValorDoSubsidio"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      staticClass: "formulario__input destacar-campos",
      attrs: {
        "id": 'subsidio-faixa-' + (index + 1),
        "type": "text",
        "placeholder": 'Insira o valor de subsídio da faixa ' + (index + 1),
        "required": ""
      },
      domProps: {
        "value": (distribuicaoPorFaixa.ValorDoSubsidio)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(distribuicaoPorFaixa, "ValorDoSubsidio", $event.target.value)
        }
      }
    })])
  }), 0), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, _vm._l((_vm.aporte.distribuicoesDoAportePorFaixa), function(distribuicaoPorFaixa, index) {
    return _c('div', {
      key: index,
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label",
      attrs: {
        "for": 'subsidio-terreno-publico-faixa-' + (index + 1)
      }
    }, [_vm._v("\n                        Subsídio Terreno Público da " + _vm._s(distribuicaoPorFaixa.NomeDaFaixa) + "\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (distribuicaoPorFaixa.ValorDoSubsidioTerrenoPublicoDoado),
        expression: "distribuicaoPorFaixa.ValorDoSubsidioTerrenoPublicoDoado"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      staticClass: "formulario__input destacar-campos",
      attrs: {
        "id": 'subsidio-terreno-publico-faixa-' + (index + 1),
        "type": "text",
        "placeholder": 'Insira o valor para terreno público da faixa ' + (index + 1),
        "required": ""
      },
      domProps: {
        "value": (distribuicaoPorFaixa.ValorDoSubsidioTerrenoPublicoDoado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(distribuicaoPorFaixa, "ValorDoSubsidioTerrenoPublicoDoado", $event.target.value)
        }
      }
    })])
  }), 0), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, _vm._l((_vm.aporte.distribuicoesDoAportePorFaixa), function(distribuicaoPorFaixa, index) {
    return _c('div', {
      key: index,
      staticClass: "grade__linha"
    }, [_c('div', {
      staticClass: "grade__coluna grade__coluna_12"
    }, [_c('label', {
      staticClass: "formulario__label",
      attrs: {
        "for": 'percentual-faixa-' + (index + 1)
      }
    }, [_vm._v("\n                                " + _vm._s(distribuicaoPorFaixa.NomeDaFaixa) + "\n                            ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (distribuicaoPorFaixa.Percentual),
        expression: "distribuicaoPorFaixa.Percentual"
      }],
      staticClass: "formulario__input destacar-campos",
      attrs: {
        "id": 'percentual-faixa-' + (index + 1),
        "type": "number",
        "placeholder": "0% - 100%",
        "required": ""
      },
      domProps: {
        "value": (distribuicaoPorFaixa.Percentual)
      },
      on: {
        "change": function($event) {
          return _vm.atualizarGrafico()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(distribuicaoPorFaixa, "Percentual", $event.target.value)
        }
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_6 coluna-grafico"
  }, [_c('div', {
    staticClass: "grafico-container"
  }, [_c('canvas', {
    attrs: {
      "id": "graficoAporte",
      "width": "290px",
      "height": "290px"
    }
  }), _vm._v(" "), (_vm.graficoVisivel) ? _c('div', {
    staticClass: "grafico-de-aporte-legenda"
  }, [_c('ul', _vm._l((_vm.legendasDoGrafico), function(legenda, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "figura",
      style: ({
        background: legenda.Cor
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "legenda-texto"
    }, [_c('span', {
      staticClass: "titulo"
    }, [_vm._v(_vm._s(_vm.$moeda.formatar(legenda.ValorDoAporteNaFaixa)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(legenda.DescricaoDaDistribuicaoPorFaixa))])])])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('router-link', {
    staticClass: "botao botao_cinza botao_medio",
    attrs: {
      "to": ("/lista-de-aporte/" + (this.projeto.Id))
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria u-margem-esquerda-media",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Inserir\n                        aporte")])], 1)])])]), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_12"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande"
  }, [_vm._v("Preencha os campos abaixo para cadastrar o aporte")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('h3', {
    staticClass: "subtitle is-5 u-margem-superior-pequena"
  }, [_vm._v("\n                        Adicione o valor do aporte para o projeto "), _c('strong', [_vm._v("MCMV Cidades")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('h3', {
    staticClass: "subtitle is-5 u-margem-superior-pequena"
  }, [_vm._v("\n                        Defina o "), _c('strong', [_vm._v("valor do subsídio")]), _vm._v(" que cada faixa representa\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('h3', {
    staticClass: "subtitle is-5 u-margem-superior-pequena"
  }, [_vm._v("\n                        Defina o "), _c('strong', [_vm._v("valor do subsídio para terreno público doado")]), _vm._v(" que cada faixa representa\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('h3', {
    staticClass: "subtitle is-5 u-margem-superior-pequena"
  }, [_vm._v("\n                        Distribua a porcentagem para cada faixa. "), _c('strong', [_vm._v("O total deve ser exatamente\n                            100%.")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e3a438c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e3a438c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aportes/mcmv-cidades/CadastroDeAporte.vue
// module id = 1133
// module chunks = 1